<template>
	<div class="Ymx_authorization_help">
		<div class="title">Amazon亚马逊店铺授权方法</div>
		<div class="content">
			授权前须知：
			<br />1、如果店铺之前已经授权给海逊，请点击
			<span class="point">重新授权</span>，不要点击
			<span class="point">删除授权</span>
			<br />2、一个海逊账号可授权
			<span class="point">多</span>亚马逊店铺，
			<span class="point">不会</span>产生账号
			<span class="point">关联</span>
			<br />3、专业卖家才支持授权erp（非专业卖家无用户权限）
		</div>
		<div class="content">
			【1】登陆亚马逊后台【设置-用户权限】，进入亚马逊MWS开发者管理页面
			<div class="img">
				<img src="../../assets/imags/help1.png" alt />
			</div>
			【2】【授权新的开发者】
			<div class="img">
				<img src="../../assets/imags/help2.png" alt />
			</div>
			<div class="img">
				<img src="../../assets/imags/help3.png" alt />
			</div>
			【3】输入海逊的开发商名称和开发者ID
			<div class="img">
				<img src="../../assets/imags/help4.png" alt />
			</div>
			<div class="small-c">
				开发者名称输入：
				<span class="point">hyxun</span>
				<br />开发者ID，不同站点，输入不同的ID: <br />美洲站 输入:
				2930-1459-3338(无法访问)
				<!-- 2947-1221-3200 -->
				<br />欧洲站、阿联酋、沙特阿拉伯 输入: 8234-6836-8234(无法访问)
				--- 3888-0595-5981(无法访问) <br />澳洲站 输入:
				9544-7254-2632(无法访问) --- 4044-6614-4288(无法访问)
				<br />日本站、新加坡 输入: 4044-6614-4288(无法访问)
			</div>
			【4】同意授权海逊访问亚马逊的权限
			<div class="img">
				<img src="../../assets/imags/help5.png" alt />
			</div>
			【5】生成授权信息
			<div class="img">
				<img src="../../assets/imags/help6.png" alt />
			</div>
			【6】打开海逊ERP，进行店铺授权
			<div class="img">
				<img src="../../assets/imags/help7.png" alt />
			</div>
			【7】将对应信息填写进去，点击授权即完成店铺授权
			<div class="img">
				<img src="../../assets/imags/help10.png" alt />
			</div>
			<div class="small-c">
				注：授权完成一个店铺的某一个国家之后，若要继续授权该店铺同一站点的其它国家，点击重新授权后，选择需要授权的国家，然后点击授权即可，如下图所示：
			</div>
			<div class="img">
				<img src="../../assets/imags/help9.png" alt />
			</div>
			<div class="img">
				<img src="../../assets/imags/help8.png" alt />
			</div>
		</div>
		<div style="text-align: center;">
			<el-button @click="returnHelp" plain>返 回 上 一 页</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Ymx_authorization_help',
	data() {
		return {}
	},
	mounted() {},
	created() {},
	methods: {
		returnHelp() {
			this.$router.push({
				path: '/jurisdiction/Ymx_authorization',
				name: 'Ymx_authorization',
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.Ymx_authorization_help {
	overflow: hidden;
	.title {
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}
	.content {
		margin-bottom: 10px;
		line-height: 1.5;
		font-size: 18px;
		color: #555;
		.img {
			margin: 10px 0;
			text-align: center;
		}
		.small-c {
			margin: 5px 0;
			font-size: 16px;
			color: #333;
		}
	}
	.point {
		color: #e74c3c;
	}
}
</style>
